import { List, Union } from 'ts-toolbelt'

export const shallowMerge = <T extends any[]>(...args: T): Union.IntersectOf<List.UnionOf<T>> =>
  Object.assign({}, ...args)
